(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSPerfilController', SSPerfilController);

    SSPerfilController.$inject = ['SSPerfil'];

    function SSPerfilController(SSPerfil) {

        var vm = this;

        vm.sSPerfils = [];

        loadAll();

        function loadAll() {
            SSPerfil.query(function(result) {
                vm.sSPerfils = result;
                vm.searchQuery = null;
            });
        }
    }
})();
